import React from "react";
import PageHeader from "../../../components/reusable/management/PageHeader";
import StatsGrid from "../../../components/reusable/management/StatsGrid";
import RevenueOverview from "./models/finance_model/RevenueOverview";
import FinanceInsights from "./models/finance_model/FinanceInsights";

const CAFinanceDashboard = () => {
    const financeStats = [
        { id: 1, title: "Revenue This Month", value: "₹8,42,500", subtitle: "+18% from last month", icon: "wallet", color: "#16a34a" },
        { id: 2, title: "Outstanding Payments", value: "₹1,74,000", subtitle: "12 clients pending", icon: "clock", color: "#f59e0b" },
        { id: 3, title: "Expenses", value: "₹2,31,000", subtitle: "Office & Operations", icon: "creditCard", color: "#ef4444" },
        { id: 4, title: "Net Profit", value: "₹6,11,500", subtitle: "72.5% Margin", icon: "trendingUp", color: "#2563eb" },
    ];

    const topClients = [
        { id: 1, title: "ABC Pvt Ltd",    value: "₹2,40,000", subtitle: "Top 1st client" },
        { id: 2, title: "XYZ Industries", value: "₹1,75,000", subtitle: "Top 2nd client" },
        { id: 3, title: "Sunrise LLP",    value: "₹1,28,000", subtitle: "Top 3rd client" },
        { id: 4, title: "KLM Exports",    value: "₹92,000",   subtitle: "Top 4th client" },
    ];

    return (
        <>
            <PageHeader
                title="Finance Dashboard"
                subtitle="Monitor revenue, payments and profitability."
            />

            <StatsGrid cards={financeStats} />

            <RevenueOverview />
            <FinanceInsights />
            <StatsGrid cards={topClients} />
        </>
    );
};

export default CAFinanceDashboard;
